import store from 'src/store';
const state = () => ({
    rightHandSideButtons: []
});
const mutations = {
    setRightHandSideButtons(state, buttons) {
        state.rightHandSideButtons = buttons;
    }
};
const actions = {
    setRightHandSideButtons({ commit }, buttons) {
        commit('setRightHandSideButtons', buttons);
    },
    addFromLeftToRightHandSideButtons({ commit, state }, buttons) {
        commit('setRightHandSideButtons', [...buttons, ...state.rightHandSideButtons]);
    },
    clearRightHandSideButtons({ commit }) {
        commit('setRightHandSideButtons', []);
    },
    addFromRightToRightHandSideButtons({ commit, state }, button) {
        commit('setRightHandSideButtons', [...state.rightHandSideButtons, ...button]);
    }
};
const getters = {
    getRightHandSideButtons: (state) => state.rightHandSideButtons
};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
export function addFromLeftToRightHandSideButtons(buttons) {
    store.dispatch('topBar/addFromLeftToRightHandSideButtons', buttons);
}
export function clearRightHandSideButtons() {
    store.dispatch('topBar/clearRightHandSideButtons');
}
export function addFromRightToRightHandSideButtons(button) {
    store.dispatch('topBar/addFromRightToRightHandSideButtons', button);
}
export function getRightHandSideButtons() {
    return store.getters['topBar/getRightHandSideButtons'];
}
export function setRightHandSideButtons(buttons) {
    store.dispatch('topBar/setRightHandSideButtons', buttons);
}
